/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientClaimDto } from '../models/ClientClaimDto';
import type { CreateUserInput } from '../models/CreateUserInput';
import type { OtpType } from '../models/OtpType';
import type { SetPasswordInput } from '../models/SetPasswordInput';
import type { UpdateProfileInput } from '../models/UpdateProfileInput';
import type { UpdateUserInput } from '../models/UpdateUserInput';
import type { UserDto } from '../models/UserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountService {

    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static listUsers(): CancelablePromise<Array<UserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Account',
        });
    }

    /**
     * @param requestBody 
     * @returns UserDto OK
     * @throws ApiError
     */
    public static addUser(
requestBody?: CreateUserInput,
): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Account',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param userId 
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getUserById(
userId: number,
): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Account/{userId}',
            path: {
                'userId': userId,
            },
        });
    }

    /**
     * @param userId 
     * @param requestBody 
     * @returns UserDto OK
     * @throws ApiError
     */
    public static updateUser(
userId: number,
requestBody?: UpdateUserInput,
): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/Account/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param userId 
     * @returns any OK
     * @throws ApiError
     */
    public static removeUser(
userId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/Account/{userId}',
            path: {
                'userId': userId,
            },
        });
    }

    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getProfile(): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Account/Profile',
        });
    }

    /**
     * @param requestBody 
     * @returns UserDto OK
     * @throws ApiError
     */
    public static updateProfile(
requestBody?: UpdateProfileInput,
): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/Account/Profile',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param otpType 
     * @returns any OK
     * @throws ApiError
     */
    public static sendOtp(
otpType?: OtpType,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Account/Otp',
            query: {
                'otpType': otpType,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static setPassword(
requestBody?: SetPasswordInput,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Account/Password/Change',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param clientCode 
     * @returns ClientClaimDto OK
     * @throws ApiError
     */
    public static listAvailableClaims(
clientCode?: string,
): CancelablePromise<Array<ClientClaimDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Account/Claims',
            query: {
                'clientCode': clientCode,
            },
        });
    }

    /**
     * @param formData 
     * @returns string OK
     * @throws ApiError
     */
    public static uploadAvatarImage(
formData?: {
formFile?: Blob;
},
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Account/Upload/Avatar',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static listDefaultAvatars(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Account/Avatar/Defaults',
        });
    }

}
